<template>
  <RevDrawer
    :name="MODAL_NAMES.REFURB_PROCESS"
    :title="i18n(translations.drawerTitle)"
  >
    <template #body>
      <div class="flex flex-col gap-16">
        <YoutubeVideo
          class="aspect-video w-full rounded-lg"
          :is-mobile="true"
          video-id="ZEB3EcDwsb0"
        />

        <ol class="bg-surface-default-low rounded-sm px-16 py-32">
          <USRefurbProcessStep
            :stepContent="i18n(translations.step1Content)"
            :stepTitle="i18n(translations.step1Title)"
            stepNumber="1"
          />
          <USRefurbProcessStep
            :stepContent="i18n(translations.step2Content)"
            :stepTitle="i18n(translations.step2Title)"
            stepNumber="2"
          />
          <USRefurbProcessStep
            :stepContent="i18n(translations.step3Content)"
            :stepTitle="i18n(translations.step3Title)"
            stepNumber="3"
          />
          <USRefurbProcessStep
            :stepContent="i18n(translations.step4Content)"
            :stepTitle="i18n(translations.step4Title)"
            stepNumber="4"
          />
          <USRefurbProcessStep
            lastStep
            :stepContent="i18n(translations.step5Content)"
            :stepTitle="i18n(translations.step5Title)"
            stepNumber="5"
          />
        </ol>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import YoutubeVideo from '~/scopes/product-core/components/presentationals/GalleryNew/components/YoutubeVideo/YoutubeVideo.vue'
import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './USRefurbProcessDrawer.translations'
import USRefurbProcessStep from './components/USRefurbProcessStep/USRefurbProcessStep.vue'

const i18n = useI18n()
</script>
